"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.TermsOfServicePage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _TermsOfService = require("../../../components/TermsOfService");

var _TermsOfService2 = require("./TermsOfService");

var _ReactStaticPage = require("../../page/ReactStaticPage");

var _reactStatic = require("react-static");

var _dec, _class;

var TermsOfServicePage = (_dec = (0, _mobxReact.inject)("siteConfig"), _dec(_class = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TermsOfServicePage, _Component);

  function TermsOfServicePage(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = TermsOfServicePage.prototype;

  _proto.render = function render() {
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: _TermsOfService2.TermsOfServiceTitle,
      seoMetadata: _TermsOfService2.TermsOfServiceSeoMetadata
    }, this.props), _react.default.createElement(_TermsOfService.TermsOfService, {
      siteName: this.props.siteConfig.siteTitle
    }));
  };

  return TermsOfServicePage;
}(_react.Component)) || _class) || _class);
exports.TermsOfServicePage = TermsOfServicePage;

var _default = (0, _reactStatic.withRouteData)(TermsOfServicePage);

exports.default = _default;